module.exports = __webpack_public_path__ + "img/p1-desc.ce6b2f62.jpg";